import { IMAGES, PSYCHOLOGIST } from "../../lib/site";

export const About = () => {
    return (
        <section id="sobre" data-testid="about-section" className="py-24 lg:py-32 relative">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                <div className="lg:col-span-5 relative order-2 lg:order-1 reveal">
                    <div className="editorial-frame relative aspect-[4/5]">
                        <img
                            src={IMAGES.about}
                            alt="Luara Ainá em pé, sorrindo, no consultório"
                            className="w-full h-full object-cover"
                            data-testid="about-image"
                        />
                    </div>
                    <div className="absolute -bottom-8 -left-4 lg:-left-10 bg-[#F5F4F2] py-5 px-6 border-l-2 border-[#9f1e1e] max-w-[260px] shadow-lg">
                        <p className="font-display italic text-xl text-[#9f1e1e] leading-snug">{PSYCHOLOGIST.years} anos</p>
                        <p className="text-xs uppercase tracking-[0.2em] text-[#2F2F2F]/60 mt-1">de clínica</p>
                    </div>
                </div>

                <div className="lg:col-span-7 order-1 lg:order-2 reveal reveal-delay-1">
                    <p className="overline mb-5">Sobre Luara Ainá</p>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.08] text-[#2F2F2F]">
                        Uma escuta madura, baseada em evidências —
                        <span className="italic text-[#9f1e1e]"> e profundamente humana.</span>
                    </h2>

                    <p className="drop-cap mt-10 text-[17px] leading-[1.85] text-[#2F2F2F]/85">
                        Sou psicóloga clínica há {PSYCHOLOGIST.years} anos, com atuação voltada para adultos e casais. 
                        Meu trabalho é ajudar pessoas a compreenderem suas emoções, fortalecerem seus relacionamentos e desenvolverem uma vida mais consciente e leve.
                    </p>

                    <p className="mt-6 text-[17px] leading-[1.85] text-[#2F2F2F]/80">
                        Minha prática é baseada na Análise do Comportamento, ACT, FAP e DBT, unindo ciência, acolhimento e escuta genuína. Também  sou sócia e proprietária da clinica de psicologia Espaço Viver Bem.
                        Acredito que, quando existe um espaço seguro para se olhar com honestidade e cuidado, é possível transformar padrões, construir relações mais saudáveis e viver com mais autenticidade.
                    </p>

                    <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5">
                        <Credit title="Formação clínica" body="Psicóloga · CRP 01/17472" />
                        <Credit title="Abordagens" body="AC · DBT · ACT · FAP · TFC · CASAL" />
                        <Credit title="Especialidade" body="Adultos e relacionamentos afetivos" />
                        <Credit title="Liderança" body="Coordenação clínica no Comporte-se" />
                    </div>
                </div>
            </div>
        </section>
    );
};

const Credit = ({ title, body }) => (
    <div className="border-t border-[#B7A6B0]/50 pt-4">
        <p className="overline text-[10px] mb-2">{title}</p>
        <p className="text-sm text-[#2F2F2F]/85 leading-relaxed">{body}</p>
    </div>
);
